import { endpoints } from '@/api/endpoints.ts'
import { axiosAPI } from '@/api/repository/repository.ts'
import { SoundsList } from '@/model/sounds-list.ts'

class SystemSoundsRepository {
  async list (): Promise<SoundsList> {
    const response = await axiosAPI.get(`${endpoints.systemSound}`)
    return SoundsList.fromJson(response.data)
  }

  async create (formData: FormData) {
    await axiosAPI.put(`${endpoints.systemSound}`, formData)
  }

  async delete (name: string) {
    await axiosAPI.delete(`${endpoints.systemSound}/${encodeURIComponent(name)}`)
  }

  async getSoundBlobUrl (name: string): Promise<string> {
    const response = await axiosAPI.get(
      `${endpoints.systemSound}/${encodeURIComponent(name)}`,
      {
        responseType: 'blob',
      },
    )

    // Create a local URL pointing to the downloaded binary data
    return URL.createObjectURL(response.data)
  }

  async updateSystemSound (name: string, data: { description: string }): Promise<void> {
    await axiosAPI.put(`${endpoints.systemSound}/${encodeURIComponent(name)}`, data)
  }
}

export const systemSoundsRepository = new SystemSoundsRepository()
